import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormArray } from '@angular/forms';
import { DynamicTableEditorComponent } from '../dynamic-table-editor/dynamic-table-editor.component';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-table-editor',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DynamicTableEditorComponent],
  template: `
    <app-dynamic-table-editor
      [formArray]="formArray"
      [factory]="config.arrayConfig?.factory"
      [itemValidators]="config.arrayConfig?.itemValidators || {}"
      [arrayConfig]="config.arrayConfig" />
  `
})
export class TableEditorFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formArray(): FormArray { return this.control as FormArray; }
}
